<template>
  <div>
    <div class="advantagelist" ref="showCounttext">
      <div style="width: 80%; max-width: 1200px; margin: 50px auto">
        <div  style="text-align: center; margin-bottom: 29px">
          <!-- <span
            class="Header_line"
            style="margin-right: 20px"
          ></span> -->
          <span
            style="
              font-size: 40px;
              font-family: 'Source Han Sans CN';
              font-weight: bold;
            "
            >服务流程</span
          >
          <!-- <span
            class="Header_line"
            style="margin-left: 20px"
          ></span> -->
        </div>
        <div class="img-banner">
          <img src="@/assets/pic_process.png" alt="" />
        </div>
        <div class="weAllwrap">
          <div class="count_center">
            <div class="pic-size">
              <div class="service-pot-1">
                <img
                  style="animation-delay: 0.3s"
                  :class="
                    show1 ? 'animate__animated animate__zoomInDown' : 'disNone'
                  "
                  src="@/assets/service-1.png"
                  alt=""
                />
              </div>
            </div>
            <div class="count_center" style="margin-top: 33px">
              <p class="service-line">线上下单</p>
              <p class="service-info">实时查价，一键下单</p>
            </div>
          </div>
          <div style="margin-top: 45px">
            <img src="../../../assets/indexImg/set.png" alt="" />
          </div>
          <div class="count_center">
            <div class="pic-size">
              <div class="service-pot-1">
                <img
                  style="animation-delay: 0.3s"
                  :class="
                    show2 ? 'animate__animated animate__zoomInDown' : 'disNone'
                  "
                  src="@/assets/service-2.png"
                  alt=""
                />
              </div>
            </div>
            <div class="count_center" style="margin-top: 33px">
              <p class="service-line">上门揽收</p>
              <p class="service-info">确认货物件数/重量/体积</p>
            </div>
          </div>
          <div style="margin-top: 45px">
            <img src="../../../assets/indexImg/set.png" alt="" />
          </div>
          <div class="count_center">
            <div class="pic-size">
              <div class="service-pot-1">
                <img
                  style="animation-delay: 0.3s"
                  :class="
                    show3 ? 'animate__animated animate__zoomInDown' : 'disNone'
                  "
                  src="@/assets/service-3.png"
                  alt=""
                />
              </div>
            </div>
            <div class="count_center" style="margin-top: 33px">
              <p class="service-line">订舱出港</p>
              <p class="service-info">系统通知、货物追踪</p>
            </div>
          </div>
          <div style="margin-top: 45px">
            <img src="../../../assets/indexImg/set.png" alt="" />
          </div>
          <div class="count_center">
            <div class="pic-size">
              <div class="service-pot-1">
                <img
                  style="animation-delay: 0.3s"
                  :class="
                    show4 ? 'animate__animated animate__zoomInDown' : 'disNone'
                  "
                  src="@/assets/service-4.png"
                  alt=""
                />
              </div>
            </div>
            <div class="count_center" style="margin-top: 33px">
              <p class="service-line">清关配送</p>
              <p class="service-info">高效清关，配送到门/仓</p>
            </div>
          </div>
          <div style="margin-top: 45px">
            <img src="../../../assets/indexImg/set.png" alt="" />
          </div>
          <div class="count_center">
            <div class="pic-size">
              <div class="service-pot-1">
                <img
                  style="animation-delay: 0.3s"
                  :class="
                    show5 ? 'animate__animated animate__zoomInDown' : 'disNone'
                  "
                  src="@/assets/service-5.png"
                  alt=""
                />
              </div>
            </div>
            <div class="count_center" style="margin-top: 33px">
              <p class="service-line">线上签收</p>
              <p class="service-info">回单回传，配送完成</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    THFdata: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      currentScroll: 0,
      show0: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleScroll() {
      this.currentScroll = window.pageYOffset;
      if (this.currentScroll - this.$refs.showCounttext.offsetTop >= (-580)) {
        let that = this;
        setTimeout(function () {
          that.show1 = true;
        }, 100);
        setTimeout(function () {
          that.show2 = true;
        }, 300);
        setTimeout(function () {
          that.show3 = true;
        }, 600);
        setTimeout(function () {
          that.show4 = true;
        }, 900);
        setTimeout(function () {
          that.show5 = true;
        }, 1200);
      }
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.disNone {
  display: none;
}
.cardItem {
  position: relative;
  width: 100%;
  height: 100%;
  float: left;
  background: url("../../../assets/indexImg/advantageBG1.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 15px;
  box-shadow: 0px 5px 57px 0px rgba(185, 185, 185, 0.4);
}
.wraoSon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 342px;
}
.advantagelist {
  float: left;
  box-sizing: border-box;
  width: 100%;
  background: #f5f5f5;
}
.weAllwrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.wrapItem {
  width: 20%;
  height: 536px;
  float: left;
  background: #ffffff;
  padding: 0 10px;
  box-sizing: border-box;
}
.wrapItem >>> .el-card {
  border: none;
  border-radius: 15px;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}

.img-banner {
  margin-bottom: 20px;
}

.pic-size {
  width: 100px;
  height: 100px;
}

.service-line {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #331318;
}

.service-info {
  margin-top: 10px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
}

.service-pot {
  width: 100px;
  height: 100px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  text-align: center;
  line-height: 146px;
}
.service-pot-1 {
  width: 100px;
  height: 100px;
  background: rgba(185, 57, 71, 0);
  border: 2px solid #FF4D01;
  border-radius: 50%;
  text-align: center;
  line-height: 146px;
}
.service-pot-1:hover{
  background: #FF4D01;
}
.Header_line {
  display: inline-block;
  width: 133px;
  border-top: 2px solid #FF4D01;
  vertical-align: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/Service.vue